var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-controller-row c-station-slide",
      class: { active: _vm.active }
    },
    [
      _c("div", { staticClass: "c-controller-column--small" }, [
        _c(
          "button",
          {
            staticClass: "c-controller-column-button",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("activate", _vm.slide)
              }
            }
          },
          [
            _c("span", { staticClass: "c-controller-indicator" }),
            _vm._v("\n\t\t\t" + _vm._s(_vm.slide.name) + "\n\t\t")
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-controller-column--time" }, [
        _vm._v("\n\t\t\t" + _vm._s(_vm.slide.settings.duration || "") + "\n\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-controller-column" }, [
        _vm.subtitle
          ? _c("p", { staticClass: "c-controller-column__title" }, [
              _vm._v(_vm._s(_vm.subtitle))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.active
          ? _c(
              "div",
              { staticClass: "c-controller-content" },
              [
                _vm.listItems
                  ? _c(
                      "ul",
                      { staticClass: "c-controller-column__list" },
                      _vm._l(_vm.listItems, function(item) {
                        return _c("li", [_vm._v(_vm._s(item))])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showControls
                  ? _c(_vm.slide.type, {
                      tag: "component",
                      attrs: { slide: _vm.slide },
                      on: { subcommand: _vm.subcommand }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button c-station-slide__next",
                    on: {
                      click: function($event) {
                        return _vm.$emit("next", _vm.slide)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.slide.settings.next))]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }